import styled from "styled-components";

export const Box = styled.div`

.interDisplay {
    font-family: InterDisplay;
  }
  .defaultText {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, sans-serif;
  }
      
  :root {
    --primary-color: #4f46e5;
    --primary-hover: #4338ca;
    --text-primary: #111827;
    --text-secondary: #6b7280;
    --bg-primary: #f3f4f6;
    --bg-white: #ffffff;
    --border-color: #e5e7eb;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  input#urlInput {
    padding: 8px 20px !important;
  }
    html, body {
  overflow: hidden;
}
  body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      "Helvetica Neue", Arial, sans-serif;
    background-color: #f3f4f6;
    color: #111827;
    line-height: 1.5;
  }

  .container_robots {
    // min-height: 100vh;
  }

  .container_robots header {
    // /* background-color: var(--bg-white); */
    // /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); */
    padding: 1rem 1rem;
  }

  .container_robots .header-content {
    max-width: 64rem;
    margin: 0 auto;
    display: flex;
    align-items: center;
    gap: 1rem;
    justify-content: center;
    text-align: center;
  }

  .container_robots .icon {
    color: #4f46e5;
    flex-shrink: 0;
  }

  .container_robots h1 {
    font-size: 1.5rem;
    font-weight: 700;
    color: #111827;
  }

  .container_robots header p {
    font-size: 0.875rem;
    color: #6b7280;
    margin-top: 0.25rem;
  }

  .container_robots main {
    max-width: 64rem;
    margin: 0 auto;
  }

  .container_robots .input-section {
  border: 1px solid #d1d5db;
    background-color: #f4f4f4;
    // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    padding: 1rem;
    margin-bottom: 1rem;
    text-align: center;
  }

  .container_robots label {
    display: block;
    font-size: 0.875rem;
    font-weight: 500;
    color: #111827;
    margin-bottom: 0.5rem;
  }

  .container_robots .input-group {
    display: flex;
    gap: 0.5rem;
  }

  .container_robots .input-section label {
  font-size: 1.2rem;  /* smaller text */
  font-weight: 500;    /* keep it readable */
  display: block;
  margin-bottom: 0.5rem;
}


  .container_robots input[type="url"] {
    flex: 1;
    padding: 0.5rem 0.75rem;
    border: 1px solid #e5e7eb
    border-radius: 0.375rem;
    font-size: 0.875rem;
    outline: none;
    transition: border-color 0.15s ease;
  }
  .container_robots form#urlForm {
    text-align: center;
  }
  .container_robots input[type="url"]:focus {
    border-color: #4f46e5;
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
  }

  .container_robots button {
    background-color: #4f46e5;
    color: white;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 0.375rem !important;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.15s ease;
  }

  .container_robots button:hover {
    background-color: #4338ca;
  }

  .container_robots .hidden {
    display: none;
  }

  .container_robots .results-section {
    background-color: #ffffff;
    border-radius: 0.5rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    margin-bottom: 2rem;
  }

  .container_robots table {
    width: 100%;
    border-collapse: collapse;
  }

  .container_robots th,
  td {
    padding: 0.75rem 1rem;
    text-align: left;
    border-bottom: 1px solid #e5e7eb;
  }

  .container_robots th {
    background-color: #f9fafb;
    font-size: 0.75rem;
    font-weight: 500;
    text-transform: uppercase;
    color: #6b7280;
  }

  .container_robots td {
    font-size: 0.875rem;
  }

  .container_robots .status-badge {
    display: inline-flex;
    align-items: center;
    padding: 0.25rem 0.75rem;
    border-radius: 9999px;
    font-weight: 500;
    font-size: 0.75rem;
  }

  .container_robots .status-allowed {
    background-color: #dcfce7;
    color: #166534;
  }

  .container_robots .status-blocked {
    background-color: #fee2e2;
    color: #991b1b;
  }

  .container_robots .recommendations-section {
    background-color: #ffffff;
    border-radius: 0.5rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    // padding: 1.5rem;
  }

  .container_robots .recommendations-section h2 {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }
  .container_robots input#urlInput {
    padding: 8px 20px !important;
    border: 1px solid #ccc9c9;
    width: 500px;
    max-width: 100%;
    margin: 0 auto;
  }
  .container_robots .recommendation-card {
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    padding: 1rem;
    margin-bottom: 1rem;
  }
  .container_robots .but_imp {
    margin: 0 auto !important;
  }
  .container_robots .recommendation-card:last-child {
    margin-bottom: 0;
  }

  .container_robots .recommendation-title {
    font-weight: 500;
    margin-bottom: 0.5rem;
  }

  .container_robots .recommendation-description {
    color: #6b7280;
    font-size: 0.875rem;
    margin-bottom: 0.75rem;
  }

  .container_robots .recommendation-code {
    background-color: #f9fafb;
    padding: 0.75rem;
    border-radius: 0.375rem;
    font-family: monospace;
    font-size: 0.875rem;
    white-space: pre-wrap;
  }

  @media (max-width: 640px) {
    .container_robots .input-group {
      flex-direction: column;
    }

    .container_robots button {
      width: 100%;
    }

    .container_robots th,
    td {
      padding: 0.5rem;
    }
  }


    .input-section {
    background: var(--bg-white);
    border: 1px solid var(--border-color);
    border-radius: 0.75rem;
    padding: 1rem;
    margin-bottom: 1.5rem;
    box-shadow: 0 1px 4px rgba(0,0,0,0.05);
    margin-left: auto;
    margin-right: auto;
  }

  .input-section label {
    display: block;
    font-weight: 500;
    margin-bottom: 0.5rem;
    font-size: 0.95rem;
    text-align: left;
  }

  .input-group {
    display: flex;
    gap: 0.5rem;
    flex-wrap: nowrap;
  }

  input#urlInput {
    flex: 1;
    padding: 0.65rem 1rem;
    font-size: 0.9rem;
    border: 1px solid var(--border-color);
    border-radius: 0.5rem;
    outline: none;
    transition: all 0.2s ease;
  }

  input#urlInput:focus {
    border-color: var(--primary-color);
    box-shadow: 0 0 0 3px rgba(79,70,229,0.1);
  }

 

  .but_imp:hover {
    background: var(--primary-hover);
  }

  /* Results table */
  .results-section {
    background: var(--bg-white);
    border-radius: 0.75rem;
    box-shadow: 0 1px 4px rgba(0,0,0,0.05);
    overflow-x: auto;
    margin-bottom: 2rem;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    min-width: 600px;
  }

  th, td {
    padding: 0.75rem 1rem;
    text-align: left;
    border-bottom: 1px solid var(--border-color);
  }

  th {
    font-size: 0.75rem;
    text-transform: uppercase;
    color: var(--text-secondary);
    background: var(--bg-primary);
    font-weight: 600;
  }

  td {
    font-size: 0.9rem;
    color: var(--text-primary);
  }

  .status-badge {
    display: inline-block;
    padding: 0.25rem 0.65rem;
    font-size: 0.75rem;
    font-weight: 500;
    border-radius: 9999px;
  }

  .status-allowed {
    background: #dcfce7;
    color: #166534;
  }

  .status-blocked {
    background: #fee2e2;
    color: #991b1b;
  }

  /* Recommendations grid */
  .recommendations-section {
    background: var(--bg-white);
    border-radius: 0.75rem;
    box-shadow: 0 1px 4px rgba(0,0,0,0.05);
    padding: 1rem;
  }

  .recommendations-section h2 {
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }

  #recommendationsList {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1rem;
  }

  .recommendation-card {
    border: 1px solid var(--border-color);
    border-radius: 0.5rem;
    padding: 1rem;
    background: var(--bg-primary);
    transition: box-shadow 0.2s ease;
  }

  .recommendation-card:hover {
    box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  }

  .recommendation-title {
    font-weight: 600;
    margin-bottom: 0.4rem;
  }

  .recommendation-description {
    font-size: 0.85rem;
    color: var(--text-secondary);
    margin-bottom: 0.75rem;
  }

  .recommendation-code {
    background: var(--bg-white);
    padding: 0.5rem;
    border-radius: 0.375rem;
    font-family: monospace;
    font-size: 0.85rem;
    white-space: pre-wrap;
  }

  @media (max-width: 640px) {
    .input-group {
      flex-direction: column;
    }
    .but_imp {
      width: 100%;
    }
    table {
      font-size: 0.8rem;
    }
  }
    .mode-switch {
  display: flex;
  padding: 6px;
  border-radius: 50px;
  width: fit-content;
  gap: 5px;
}

.toggle-btn {
  padding: 10px 22px;
  border: none;
  border-radius: 40px;
  font-size: 14px;
  font-weight: 600;
  background: transparent;
  color: #555;
  cursor: pointer;
  transition: all 0.25s ease-in-out;
}

.toggle-btn:hover {
  background: #e8e8e8;
}

.toggle-btn.active {
  background: #8CC540;
  color: #ffffff;
  box-shadow: 0px 3px 8px rgba(0,0,0,0.15);
  transform: translateY(-1px);
}
/* Force remove the unwanted indigo color (#4F46E5) */
.toggle-btn,
.toggle-btn.active,
.mode-switch button,
.mode-switch .active {
  color: #fff !important;
  background-color: #8CC540 !important;
  border-color: #8CC540 !important;
}

/* NON-active button (not selected) */
.toggle-btn:not(.active) {
  background-color: #f4f4f4 !important;
  color: #555 !important;
}
.input-section form {
  text-align: left !important;
}

.input-section form input[type="file"] {
  margin-top: 8px;
}

/* ---------------- TAB BAR ----------------- */
.mode-switch {
  display: flex;
  align-items: center;
  gap: 0;
  background: #f0f2f4;
  border: 1px solid #d0d5da;
  border-bottom: none;
  width: fit-content;
  border-radius: 6px 6px 0 0;
  padding: 0;
  margin-top: 20px;
}

/* Tab Buttons */
.toggle-btn {
  padding: 12px 24px;
  background: transparent;
  border: none;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  color: #333;
  border-right: 1px solid #d0d5da;
  transition: 0.2s ease;
}

.toggle-btn:last-child {
  border-right: none;
}

/* Active Tab (White + Attached) */
.toggle-btn.active {
  background: #ffffff;
  color: #000;
  border-bottom: 2px solid #ffffff;
}

/* ---------------- CONTENT PANEL ----------------- */
.input-section {
  margin-top: 0;
  padding: 25px;
  background: #ffffff;
  border: 1px solid #d0d5da;
  border-radius: 0 6px 6px 6px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

/* Label */
.input-section label {
  font-weight: 600;
  margin-bottom: 8px;
  display: inline-block;
  font-size: 15px;
}

/* Input */
.input-group input {
  padding: 14px 16px;
  border-radius: 6px;
  border: 1px solid #ccc;
  flex: 1;
  min-width: 0;
  font-size: 15px;
}



.but_imp {
  width: 200px !important;
  height: 48px !important;

  padding: 0 !important;       
  border-radius: 6px;

  font-size: 15px;
  font-weight: 600;
  line-height: 48px;           

  white-space: nowrap;
  overflow: hidden;

  display: block;               
  text-align: center;

  box-sizing: border-box;
}

@media (max-width: 640px) {

  .mode-switch {
    width: 100%;
    flex-wrap: wrap;
    border-radius: 8px;
  }

  .toggle-btn {
    flex: 1 1 33.33%;
    padding: 10px 8px;
    font-size: 13px;
    border-right: none;
    border-bottom: 1px solid #d0d5da;
    text-align: center;
    white-space: nowrap;
  }

  .toggle-btn:last-child {
    border-bottom: none;
  }

  .toggle-btn.active {
    border-bottom: 1px solid #ffffff;
  }
}

.paste-url-row {
  display: flex;
  gap: 10px;
}

@media (max-width: 640px) {
  .paste-url-row {
    flex-direction: column;
  }

  .paste-url-row button {
    width: 100%;
  }
}

@media (max-width: 640px) {
  .input-section input[type="file"] {
    width: 100%;
     margin-bottom: 16px;
  }

  .but_imp {
    width: 100% !important;
  }
}


`;
